<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" md="4">
            <v-text-field v-model="title" placeholder="Tên lớp" clearable flat outlined dense hide-details />
          </v-col>
          <v-col class="pb-0" cols="12" md="4">
            <v-select
              :items="[{t: 'Cơ sở A'}, {t: 'Cơ sở 1'}]"
              item-text="t"
              item-value="t"
              v-model="department"
              placeholder="Cơ sở"
              :disabled="isDeparmentFilterDisabled"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="type"
              :items="[{t: 'Khối 6'}, {t: 'Khối 10'}]"
              placeholder="Khối"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="t"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="2">
        <v-btn color="admin" height="40px" width="100%" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({user: 'auth/user'}),
    isDeparmentFilterDisabled() {
      return this.user.department !== 'both'
    },
  },
  created() {
    if (this.user.department === 'both') this.department = ''
    else this.department = this.user.department
  },
  data: () => ({department: '', type: '', title: ''}),
  methods: {
    onFilterChanged() {
      const query = {type: this.type, title_contains: this.title}
      if (!this.department || this.department === 'both') query.department_in = ['unset', 'Cơ sở 1', 'Cơ sở A']
      else query.department_in = ['unset', this.department]
      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
